/** @file attachmentPlans: attachment plans per puppet, written by bindAttachmentClips, read by evaluate. */
import type { Puppet } from '@zilo/pose3d-format/types/puppet';
import type { AttachmentPlan } from '@zilo/pose3d-pose/attach/attachTypes';

/** Plans by puppet object; a puppet never bound evaluates without attachment clips. */
export const attachmentPlans = new WeakMap<Puppet, AttachmentPlan[]>();
